import React, { useContext, useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { findTrailsByUserId, removeTrail } from '../models/actions/Trails';
import '../App.css';
import compose from 'recompose/compose';
import SpText from '../components/atoms/SpText';
import SpButton from '../components/atoms/SpButton';
import { ArrowBack, DeleteForever } from '@material-ui/icons';
import SpSearch from '../components/atoms/SpSearch';
import SpDialog from '../components/atoms/SpDialog';
import SpIconAndTextButton from '../components/atoms/SpIconAndTextButton';
import SpIconButton from '../components/atoms/SpIconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { styled } from '../components/styled';
import { Grid, TableCell } from '@material-ui/core';
import { SpTable, SpTableCell, SpTableRow } from '../components/bundles/SpTable';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import { theme } from '../components/theme';
import { isMobile } from 'react-device-detect';
import { UserSessionContext } from '../App';

const TrailsList = (props) => {
  const [currentPatient, setCurrentPatient] = useState();
  const [searchString, setSearchString] = useState();
  const [stationsList, setTrails] = useState([]);
  const [displayTrails, setDisplayTrails] = useState([]);
  const [openDeleteTrail, setOpenDeleteTrail] = useState(false);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const history = useHistory();

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const response = await findTrailsByUserId({ id_user: authData.userId }, authData.accessToken);
      response && setTrails(response);
      response && setDisplayTrails(response);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const filterTrails = (e) => {
    let newDisplayFilters = stationsList?.filter((row) => row.name.trim().toLowerCase().includes(e.currentTarget.value.toString().trim().toLowerCase()));
    setDisplayTrails(newDisplayFilters);
    if (e.currentTarget.value === '') setDisplayTrails(stationsList);
    setSearchString(e.currentTarget.value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const removeTrailById = async () => {
    try {
      let response = await removeTrail({ id_trail: openDeleteTrail.data.id }, authData.accessToken);
      setOpenDeleteTrail({ status: false, data: null });
      response && fetchData();
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  });

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: 'Nome',
      isAction: false
    },
    {
      id: 'duration',
      numeric: false,
      disablePadding: false,
      label: 'Durata',
      isAction: false
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];

  //rendering the profile editing form
  const TrailsRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <>
        <SpTableRow
          role="checkbox"
          id={row?.group?.id}
          tabIndex={index}
        >
          <SpTableCell>
            <SpIconAndTextButton
              isIconRight={true}
              textVariant="tableText"
              text={row.title}
              onClick={() => history.push(`/trails/edit/${row?.id}`)}
            >
              <ArrowForwardIosIcon style={{ width: 10, color: theme.colors.mainGreen.main, height: 30, cursor: 'pointer' }} />
            </SpIconAndTextButton>
          </SpTableCell>
          <SpTableCell>
            <SpText variant="tableText">{row.duration}</SpText>
          </SpTableCell>
          <TableCell
            align={'right'}
            style={{
              padding: 0,
              verticalAlign: 'bottom',
              borderBottom: 0
            }}
          >
            <SpIconButton
              variant={'standard'}
              type="tableList"
              text={''}
              onClick={() => {
                setOpenDeleteTrail({ status: true, data: row });
              }}
            >
              <DeleteForever />
            </SpIconButton>
          </TableCell>
        </SpTableRow>
      </>
    );
  };

  return (
    <>
      <Grid
        container
        style={{ paddingLeft: '1%' }}
        direction="column"
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TitleToolbarSection>
            <SpText
              variant="h1"
              style={{ marginRight: '5px' }}
            >{`PERCORSI `}</SpText>
          </TitleToolbarSection>
        </Grid>
        <Grid
          item
          container
          xs={12}
          direction="row"
          spacing={3}
          alignItems="center"
        >
          <Grid
            item
            xs={7}
          >
            <SpSearch
              onChange={(e) => filterTrails(e)}
              value={searchString}
              searchStyle={{ width: '100%' }}
              style={{ marginRight: '5px' }}
            />
          </Grid>
          <Grid
            item
            xs={5}
          >
            <SpButton
              buttonType={'accept'}
              onClick={() => history.push('/trails/edit')}
              text={'Aggiungi percorso'}
              style={{ marginLeft: '10%' }}
            />
          </Grid>
        </Grid>
        {displayTrails && displayTrails?.length === 0 && (
          <Grid
            container
            item
            xs={12}
            style={{ marginTop: '1%' }}
          >
            <SpText variant="h1PageSubtitle">Non ci sono percorsi!</SpText>
          </Grid>
        )}
        {displayTrails && displayTrails?.length > 0 && (
          <Grid
            item
            xs={12}
          >
            <SpTable
              pagination={true}
              headCells={headCells}
              rows={displayTrails}
              rowKey="id"
              padding={false}
              notCheckable={false}
              tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
            >
              <TrailsRow />
            </SpTable>
          </Grid>
        )}
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={openDeleteTrail.status}
        setOpen={setOpenDeleteTrail}
        title={'Elimina percorso'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler eliminare il percorso?'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => removeTrailById()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => setOpenDeleteTrail({ status: false, data: null })}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(TrailsList);
